<template>
    <div v-if="className == 'sub-tab-wrap'">
        <template v-for="item in gnbs">
            <ul class="tab tab--underline" :key="item.title" v-if="item.title == sh">
                <li v-for="child in item.children" :key="child.title" class="tab__li" :class="{ active: tabActive == child.title }">
                    <a :href="child.path" class="tab__btn">
                        <span v-if="child.tabTitle">{{ child.tabTitle }}</span>
                        <span v-else>{{ child.title }}</span>
                    </a>
                </li>
            </ul>
        </template>
    </div>
    <ul v-else :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <a v-if="item.href" :href="item.href" :class="className + '__link'" target="_blank"
                    ><h2>{{ item.title }}</h2></a
                >
                <router-link v-else :to="item.path" :class="className + '__link'"
                    ><h2>{{ item.title }}</h2></router-link
                >
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div v-if="isMobile" :class="className + '__link gnb__link--toggle'">
                    <h2>{{ item.title }}</h2>
                </div>
                <router-link v-else :to="item.path" :class="className + '__link gnb__link--toggle'"
                    ><h2>{{ item.title }}</h2></router-link
                >
                <ul :class="className + '__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{ child.title }}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
        sh: String,
        tabActive: String,
    },
    data: function () {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "About IST",
                    path: "/en/about/histroy",
                    children: [
                        {
                            title: "Company History",
                            path: "/en/about/histroy",
                        },
                        {
                            title: "Partners",
                            path: "/en/about/partner",
                        },
                        {
                            title: "Certification Status",
                            path: "/en/about/status",
                        },
                    ],
                },
                {
                    title: "Machining Products",
                    path: "/en/products/CMP",
                    children: [
                        {
                            title: "CMP Retainer - Ring",
                            path: "/en/products/CMP",
                        },
                        {
                            title: "Metal",
                            path: "/en/products/metal",
                        },
                        {
                            title: "Engineering Plastic & Rubber",
                            path: "/en/products/engineering",
                        },
                    ],
                },
                {
                    title: "Distributor in Korea",
                    path: "/en/distributor/kalrez",
                    children: [
                        {
                            title: "Dupont Kalrez®",
                            path: "/en/distributor/kalrez",
                        },
                        {
                            title: "Dupont Vespel®",
                            path: "/en/distributor/dupont",
                        },
                        {
                            title: "Mitsubishi O-Ring",
                            path: "/en/distributor/oring",
                        },
                        {
                            title: "ENDO Metal-Sleeve",
                            path: "/en/distributor/endo",
                        },
                    ],
                },
                {
                    title: "What We Do",
                    path: "/en/wwd/overview",
                    children: [
                        {
                            title: "Overview",
                            path: "/en/wwd/overview",
                        },
                        {
                            title: "Smart Factory",
                            path: "/en/wwd/factory",
                        },
                        {
                            title: "Quality Control",
                            path: "/en/wwd/control",
                        },
                        {
                            title: "Safety Management",
                            path: "/en/wwd/management",
                        },
                        {
                            title: "Information Security Management",
                            tabTitle: "Information Security",
                            path: "/en/wwd/information",
                        },
                    ],
                },
                {
                    title: "Contact",
                    path: "/en/contact/location",
                    children: [
                        {
                            title: "Direction",
                            path: "/en/contact/location",
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        isDesktop: function () {
            return this.window.width >= 1200;
        },
        isMobile: function () {
            return this.window.width < 1200;
        },
    },
    created: function () {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function () {},
    methods: {
        handleResize: function () {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>